import React from 'react';
import Carousel from './Carousel';
import HowRentTwo from '../pages/HowRentTwo';
import YourDreamOne from '../pages/YourDreamOne';
import LuxuryCarOne from '../pages/LuxuryCarOne';
import AskedQuestion from '../pages/AskedQuestion';
import Testimonials from '../pages/Testimonials';
import BlogSix from '../pages/BlogSix';
import SanaviTravels from '../pages/SanaviTravels';
import SanaviBookingForm from '../pages/SanaviBookingForm';




const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



 <Carousel/>
{/* <AboutShuttle/> */}
<SanaviBookingForm/>
<YourDreamOne/>

<HowRentTwo/>
<SanaviTravels/>
<LuxuryCarOne/>
{/* <AskedQuestion/> */}
<Testimonials/>
<BlogSix/>
    </div>
  );
};

export default HeroSection;
